<template>
  <div class="container-custom">
    <!-- Breadscrumbs -->
    <Breadscrumbs
      :links="[{ name: 'SupportGroupList', to: { path: '/support-groups' } }]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>群組管理</h2>
    </div>
    <div class="h4 py-3">
      設定 Download &amp; Support 選單內各群組（Warranty/FAQ/RMA、Resources、Marketing Tools、Digital
      Marketing Materials）的標題、副標題與圖片。群組項目本身（Warranty、RMA…等）請至「群組項目設定」編輯。<br />
      另外 About Us 選單裡的「Newsletter」表單也借用這裡設定副標題與圖片（不是 Download &amp; Support 底下的項目）。
    </div>
    <!-- block -->
    <div class="block mb-5">
      <table class="w-100">
        <thead>
          <tr>
            <th class="text-left pa-3">圖片</th>
            <th class="text-left pa-3">群組</th>
            <th class="text-left pa-3">標題</th>
            <th class="text-left pa-3">副標題</th>
            <th class="text-left pa-3">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="group in groups" :key="group.type">
            <td class="pa-3">
              <img
                v-if="group.image"
                :src="group.image"
                class="w-64px h-64px"
                style="object-fit: cover; border-radius: 4px;" />
              <span v-else class="ink-02-medium--text">未設定</span>
            </td>
            <td class="pa-3">{{ group.label }}</td>
            <td class="pa-3">{{ group.title || '(未設定)' }}</td>
            <td class="pa-3">{{ group.subtitle || '(未設定)' }}</td>
            <td class="pa-3">
              <button class="btn square" @click="toEdit(group.type)">
                <v-icon>edit</v-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';

export default {
  components: {
    Breadscrumbs,
  },
  computed: {
    ...mapState('pageTitle', ['groups']),
  },
  created() {
    this.getGroups();
  },
  methods: {
    ...mapActions('pageTitle', {
      getGroups: 'findGroups',
    }),
    toEdit(type) {
      this.$router.push({ name: 'SupportGroupEdit', params: { type } });
    },
  },
};
</script>

<style></style>
